import {
  LOAD_PRODUTOS_SUCCESS,
  LOAD_PRODUTOS_FAIL,
  LOAD_PRODUTO_SUCCESS,
  LOAD_PRODUTO_FAIL,
  CREATE_PRODUTO_SUCCESS,
  CREATE_PRODUTO_FAIL,
  UPDATE_PRODUTO_SUCCESS,
  UPDATE_PRODUTO_FAIL,
  DELETE_PRODUTO_SUCCESS,
  DELETE_PRODUTO_FAIL,
} from "../actions/produto";

const initialState = {
  produtos: [],
  produtoAtual: null,
  error: null,
};

const produtoReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PRODUTOS_SUCCESS:
      return { ...state, produtos: action.payload, error: null };
    case LOAD_PRODUTOS_FAIL:
      return { ...state, produtos: [], error: action.payload };

    case LOAD_PRODUTO_SUCCESS:
      return { ...state, produtoAtual: action.payload, error: null };
    case LOAD_PRODUTO_FAIL:
      return { ...state, produtoAtual: null, error: action.payload };

    case CREATE_PRODUTO_SUCCESS:
      return {
        ...state,
        produtos: [...state.produtos, action.payload],
        error: null,
      };
    case CREATE_PRODUTO_FAIL:
      return { ...state, error: action.payload };

    case UPDATE_PRODUTO_SUCCESS:
      return {
        ...state,
        produtos: state.produtos.map((produto) =>
          produto.id === action.payload.id ? action.payload : produto
        ),
        error: null,
      };
    case UPDATE_PRODUTO_FAIL:
      return { ...state, error: action.payload };

    case DELETE_PRODUTO_SUCCESS:
      return {
        ...state,
        produtos: state.produtos.filter(
          (produto) => produto.id !== action.payload
        ),
        error: null,
      };
    case DELETE_PRODUTO_FAIL:
      return { ...state, error: action.payload };

    default:
      return state;
  }
};

export default produtoReducer;
